import { authenticatedPatch } from '../../../../../api/request';

export default async function saveUpdatedAd(saveData, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error guardando la actualización del anuncio.');
    const url = '/ads/';
    return await authenticatedPatch(url, onFail, saveData);
}
